<template>
  <v-container fluid grid-list-sm style="padding: 8px;">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title class="heading">
            Welcome
          </v-card-title>
          <v-card-text class="title">
            Thank you for joining ConnectMyChurch. <br>
            Please download the <a href="https://testflight.apple.com/join/WRXa7iP9">iOS App</a> or the
            <a href="https://play.google.com/store/apps/details?id=com.connectmychurch.connectapp">Android App</a>
            and login to get started. <br>
            If you're an administrator explore the admin functions in the menu.
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Home'
}
</script>
